import { SpacedColon } from '@mews-commander/ui';
import { LocalizedProperty, LocalizedPropertyObject, lt } from '@mews/framework';
import { Optional } from '@mews/std';
import { Typography, Body, Stack } from '@optimus-web/core';

interface Props {
    names: Optional<LocalizedPropertyObject>;
    usableResources: Optional<number>;
}
export const ResourceCategoryCell = ({ names, usableResources }: Props) => (
    <Stack vertical spacing="100">
        <Body size="small" whiteSpace="nowrap">
            <Typography textStyle="bodyMediumStrong" as="div">
                {names ? <LocalizedProperty property={names} /> : lt('AllSpaces')}
            </Typography>
        </Body>
        <Typography textStyle="bodySmall" as="div">
            {lt('SpacePlural')}
            {SpacedColon}
            {usableResources}
        </Typography>
    </Stack>
);
